import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chart"
export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    if (document.documentElement.hasAttribute("data-turbolinks-preview")) return;
    if (document.documentElement.hasAttribute("data-turbo-preview")) return;

    if (typeof Chart === "undefined") {
      console.error("Chart.js is not loaded")
      return
    }

    try {
      new Chart(this.element, this.optionsValue)
    } catch (e) {
      console.error("Error initializing chart:", e)
    }
  }
}
